import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import Image from 'next/image';
const Avatar = /*#__PURE__*/styled("div")({
  name: "Avatar",
  class: "a1nim4q4"
});
const AdAvatar = ({
  adInfo,
  adViewUrl,
  handleClickAdView
}) => {
  const handleImplementClickAdView = event => {
    if (event && handleClickAdView) {
      handleClickAdView(event, adInfo);
    }
  };
  const handleErrorImage = e => {
    const image = e.target;
    image.style.display = 'none';
  };
  return <Avatar onClick={() => handleImplementClickAdView()}>
      <a href={adViewUrl}>
        <Image alt={adInfo.name} title={adInfo.name} onError={handleErrorImage} src={adInfo.profile_image_url} layout="fill" />
      </a>
    </Avatar>;
};
AdAvatar.propTypes = {
  adViewUrl: PropTypes.string.isRequired,
  adInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array])).isRequired,
  handleClickAdView: PropTypes.func.isRequired
};
AdAvatar.defaultProps = {};
export default memo(AdAvatar);

require("../../../../../.linaria-cache/src/components/GridAdsProject/AdItem/AdAvatar/AdAvatar.linaria.module.css");